export default "__VITE_ASSET__C0e4rxGh__"